import { useMemo } from "react";
import { getArraySort } from '@gp/utils/common';

type commonCardType = {
  'end_date': string,
  'percent': string,
  'prev_value': string,
  'start_date': string,
  'value': string,
} | null;
type ResType = {
  projectCount: {[keyName: string]: number} | null,
  yearProjectCount: {
    'total': number,
    'list': {
      // 'business_owner': string,
      'cover': string,
      // 'develop_id': string,
      'entity_type': string,
      'id': string,
      'release_time': string,
      'name': string,
      // 'publish_id': string,
    }[],
  } | null,
  currentMonthGrossRevenue: commonCardType,
  ytmGrossRevenue: commonCardType,
  mau: commonCardType,
};

const FIXED_KEY_MAP: {[keyName: string]: number} = {
  'amplifier': 0,
  'astra': 0,
  'fuel': 0,
  'nexus': 0,
  'saturn': 0,
  'solar': 0,
  'others': 0,
};

export default function (props: {
  loading: boolean,
  data: IStudioOverallProjectsLiveKeyMetricsData | undefined | null,
  sourceCardMsg: {
    loading: boolean;
    data: any;
  },
}) {
  const {
    loading,
    data,
    sourceCardMsg,
  } = props;

  const orgResult = useMemo(() => {
    const res: ResType = {
      projectCount: null,
      yearProjectCount: null,
      currentMonthGrossRevenue: null,
      ytmGrossRevenue: null,
      mau: null,
      dataTime: data?.data_time || '',
    };
    const projectCountData = data?.project_counts,
          yearProjectCountData = data?.newly_launched_last_year,
          // currentMonthGrossReveneData = data?.current_month_gross_revenue,
          // ytmGrossRevenueData = data?.ytm_gross_revenue,
          // mauData = data?.mau;
          currentMonthGrossReveneData = sourceCardMsg?.data?.current_month_gross_revenue,
          ytmGrossRevenueData = sourceCardMsg?.data?.ytm_gross_revenue,
          mauData = sourceCardMsg?.data?.mau;
    // Total Project Counts Live
    if (projectCountData && Object.prototype.toString.call(projectCountData) === '[object Object]') {
      res.projectCount = {...FIXED_KEY_MAP};
      let total = 0;
      for (const key in projectCountData) {
        const tempKey = key?.trim()?.toLowerCase();
        if (typeof FIXED_KEY_MAP?.[tempKey] === 'number') {
          res.projectCount[tempKey] = res.projectCount[tempKey] + Number(projectCountData?.[key]) || 0;
        } else {
          res.projectCount['others'] = res.projectCount['others'] + Number(projectCountData?.[key]) || 0;
        }
        total = total + Number(projectCountData?.[key]) || 0;
      }
      res.projectCount['total'] = total;
    }
    // Newly launched last 12 months
    if (Array.isArray(yearProjectCountData) && yearProjectCountData?.length) {
      res.yearProjectCount = {
        'total': yearProjectCountData?.length,
        'list': getArraySort(yearProjectCountData, 'string', 'asc', 'release_time')?.map((t: any) => ({...t, date: t?.release_time})),
      };
    }
    // Current Month Gross Revenue
    if (currentMonthGrossReveneData && Object.prototype.toString.call(currentMonthGrossReveneData) === '[object Object]') {
      res.currentMonthGrossRevenue = currentMonthGrossReveneData;
    }
    // YTM Gross Revenue
    if (ytmGrossRevenueData && Object.prototype.toString.call(ytmGrossRevenueData) === '[object Object]') {
      res.ytmGrossRevenue = ytmGrossRevenueData;
    }
    // MAU
    if (mauData && Object.prototype.toString.call(mauData) === '[object Object]') {
      res.mau = mauData;
    }

    return res;
  }, [loading, sourceCardMsg?.loading]);

  return orgResult;
};
